import React from "react";

const Input = ({ type = "text", name, label="", className, required = false, onChange = () => {}, value = undefined, ...rest}) => {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm text-gray-600 font-medium mb-1" htmlFor={name}>
                    {label}
                    {required && <span className="ml-0.5 text-red-500">*</span>}
                </label>
            )}
            <input
                type={type}
                name={name}
                id={name}
                required={required}
                onChange={onChange}
                value={value}
                {...rest}
                className="w-full px-3 py-2 bg-white rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-shadow duration-150 placeholder:text-gray-400"
            />
        </div>
    )
}

export default Input;
